<template><!-- 商品頁套組介紹區塊 -->
    <div class="travelTheme" id="travelTheme" ref="infoBox">
        <div class="container scrollContainer">
            <div class="travel-nav-container">
                <div class="travel-nav-fixed">
                    <div class="title-wrapper center">
                        <h2 class="title">跟著旅遊主題買 旅行保險好簡單</h2>
                    </div>
                    <ul class="travel-nav">
<!--                        <li data-anchor="rails" class="active">-->
<!--                            <a href="#rails" class="theme_accu0"-->
<!--                               v-smooth-scroll="{ duration: 1000, offset: -321, container: '.scrollContainer' }">鐵道客運遊</a>-->
<!--                        </li>-->
                        <li data-anchor="moto">
                            <a href="#moto"
                               v-smooth-scroll="{ duration: 1000, offset: -321, container: '.scrollContainer' }">離島租車遊</a>
                        </li>
                        <li data-anchor="car">
                            <a href="#car"
                               v-smooth-scroll="{ duration: 1000, offset: -321, container: '.scrollContainer' }">租車自駕遊</a>
                        </li>
                        <li data-anchor="basic">
                            <a href="#basic"
                               v-smooth-scroll="{ duration: 1000, offset: -321, container: '.scrollContainer' }">基本保障款</a>
                        </li>
                        <li data-anchor="camp">
                            <a href="#camp"
                               v-smooth-scroll="{ duration: 1000, offset: -321, container: '.scrollContainer' }">自然露營趣</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="theme-container">
<!--                <div id="rails" class="item">-->
<!--                    <div class="image-wrapper">-->
<!--                        <img src="../../assets/travel-rails.svg" alt="國內旅平險推薦旅遊主題：鐵道客運遊">-->
<!--                        <div class="title">-->
<!--                            <h3>鐵道客運遊</h3>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="item-content">-->
<!--                        <div class="head">-->
<!--                            <div class="title">-->
<!--                                <h3>鐵道客運遊</h3>-->
<!--                            </div>-->
<!--                            <div class="prize">-->
<!--                                <p>一日保費<br>只要</p>-->
<!--                                <p class="hightlight"><span>$</span>130</p>-->
<!--                                <p>起</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="body">-->
<!--                            <p>-->
<!--                                國道或大眾運輸交通事故險<br>-->
<!--                                鐵路客運旅程延誤補償<br>-->
<!--                                旅行平安險額度300萬<br>-->
<!--                                傷害醫療險額度30萬<br>-->
<!--                                個人賠償責任險-->
<!--                            </p>-->
<!--                            <div class="prize">-->
<!--                                <p>一日保費<br>只要</p>-->
<!--                                <p class="hightlight"><span>$</span>130</p>-->
<!--                                <p>起</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <a class="btn theme_info_accu0" id="railsContent" @click="popupShow($event)">-->
<!--                            <p>瞭解完整保障</p>-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="journey">
                    <div id="moto"></div>
                    <div  class="item">
                        <div class="image-wrapper">
                            <img src="../../assets/travel-moto.svg" alt="國內旅平險推薦旅遊主題：離島租車遊">
                            <div class="title">
                                <h3>離島租車遊</h3>
                            </div>
                        </div>

                        <div class="item-content">
                            <div class="head">
                                <div class="title">
                                    <h3>離島租車遊</h3>
                                </div>
                                <div class="prize">
                                    <p>一日保費<br>只要</p>
                                    <p class="hightlight"><span>$</span>185</p>
                                    <p>起</p>
                                </div>
                            </div>
                            <div class="body">
                                <p>
                                    國內租車旅遊險(機車)<br>
                                    境內飛機旅程延誤補償<br>
                                    旅行平安險額度500萬<br>
                                    傷害醫療險額度5萬<br>
                                    個人賠償責任險
                                </p>
                                <div class="prize">
                                    <p>一日保費<br>只要</p>
                                    <p class="hightlight"><span>$</span>185</p>
                                    <p>起</p>
                                </div>
                            </div>
                            <a class="btn theme_info_accu1" id="motoContent" @click="popupShow($event)">
                                <p>瞭解完整保障</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="journey">
                    <div id="car"></div>
                    <div  class="item">
                        <div class="image-wrapper">
                            <img src="../../assets/travel-car.svg" alt="國內旅平險推薦旅遊主題：租車自駕遊">
                            <div class="title">
                                <h3>租車自駕遊</h3>
                            </div>
                        </div>

                        <div class="item-content">
                            <div class="head">
                                <div class="title">
                                    <h3>租車自駕遊</h3>
                                </div>
                                <div class="prize">
                                    <p>一日保費<br>只要</p>
                                    <p class="hightlight"><span>$</span>338</p>
                                    <p>起</p>
                                </div>
                            </div>
                            <div class="body">
                                <p>
                                    國內租車旅遊險(汽車)<br>
                                    國道或大眾運輸交通事故險<br>
                                    旅行平安險額度500萬<br>
                                    傷害醫療險額度5萬<br>
                                    個人賠償責任險
                                </p>
                                <div class="prize">
                                    <p>一日保費<br>只要</p>
                                    <p class="hightlight"><span>$</span>338</p>
                                    <p>起</p>
                                </div>
                            </div>
                            <a class="btn theme_info_accu2" id="carContent" @click="popupShow($event)">
                                <p>瞭解完整保障</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="journey">
                    <div id="basic"></div>
                    <div  class="item">
                        <div class="image-wrapper">
                            <img src="../../assets/travel-basic.svg" alt="國內旅平險推薦旅遊主題：基本保障款">
                            <div class="title">
                                <h3>基本保障款</h3>
                            </div>
                        </div>
                        <div class="item-content">
                            <div class="head">
                                <div class="title">
                                    <h3>基本保障款</h3>
                                </div>
                                <div class="prize">
                                    <p>一日保費<br>只要</p>
                                    <p class="hightlight"><span>$</span>74</p>
                                    <p>起</p>
                                </div>
                            </div>
                            <div class="body">
                                <p>
                                    旅行平安險額度300萬<br>
                                    傷害醫療險額度5萬<br>
                                    個人賠償責任險
                                </p>
                                <div class="prize">
                                    <p>一日保費<br>只要</p>
                                    <p class="hightlight"><span>$</span>74</p>
                                    <p>起</p>
                                </div>
                            </div>
                            <a class="btn theme_info_accu3" id="basicContent" @click="popupShow($event)">
                                <p>瞭解完整保障</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="journey">
                    <div id="camp"></div>
                    <div  class="item">
                        <div class="image-wrapper">
                            <img src="../../assets/travel-camp.svg" alt="國內旅平險推薦旅遊主題：自然露營趣">
                            <div class="title">
                                <h3>自然露營趣</h3>
                            </div>
                        </div>
                        <div class="item-content">
                            <div class="head">
                                <div class="title">
                                    <h3>自然露營趣</h3>
                                </div>
                                <div class="prize">
                                    <p>一日保費<br>只要</p>
                                    <p class="hightlight"><span>$</span>159</p>
                                    <p>起</p>
                                </div>
                            </div>
                            <div class="body">
                                <p class="">
<!--                                    重大燒燙傷保險<br>-->
                                    食物中毒慰問金<br>
                                    國道或大眾運輸交通事故險<br>
                                    旅行平安險額度500萬<br>
                                    傷害醫療險額度5萬<br>
                                    個人賠償責任險
                                </p>
                                <div class="prize">
                                    <p>一日保費<br>只要</p>
                                    <p class="hightlight"><span>$</span>159</p>
                                    <p>起</p>
                                </div>
                            </div>
                            <a class="btn theme_info_accu4" id="campContent" @click="popupShow($event)">
                                <p>瞭解完整保障</p>
                            </a>
                        </div>
                    </div>
                </div>




            </div>
            <p class="note center">(保費金額以投保試算頁面為準，保費將依保額、天數、人數調整)</p>
        </div>
        <div class="popup-wrapper" style="display: none;">
<!--            <div class="popup-content popup-railsContent">-->
<!--                <div class="head">-->
<!--                    <h3>鐵道客運遊 <span>保險方案推薦</span></h3>-->
<!--                </div>-->
<!--                <div class="close popup-close theme_close_accu0" @click="popupClose">-->
<!--                    <img src="../../assets/close.svg" alt="">-->
<!--                </div>-->
<!--                <div class="overFrame">-->
<!--                    <div class="body">-->
<!--                        <div class="list">-->
<!--                            <div class="list-icon">-->
<!--                                <p>推薦<br><span>1</span></p>-->
<!--                                <img src="../../assets/popup-yellow-icon.svg" alt="popupYellowIcon">-->
<!--                            </div>-->
<!--                            <div class="list-content">-->
<!--                                <p class="title">鐵道客運旅程延誤險(含在國內旅遊不便險內) </p>-->
<!--                                <p class="listCon">若因台鐵、客運誤點達4小時以上即可獲得定額2,000元補償。</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="list">-->
<!--                            <div class="list-icon">-->
<!--                                <p>推薦<br><span>2</span></p>-->
<!--                                <img src="../../assets/popup-yellow-icon.svg" alt="popupYellowIcon">-->
<!--                            </div>-->
<!--                            <div class="list-content">-->
<!--                                <p class="title">國道或大眾運輸事故保險 </p>-->
<!--                                <p class="listCon">-->
<!--                                    在國道上發生意外或是搭乘大眾運輸工具發生意外，導致不幸身故，最高理賠200萬元。</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="list">-->
<!--                            <div class="list-icon">-->
<!--                                <p class="color-black">必保<br><span>1</span></p>-->
<!--                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">-->
<!--                            </div>-->
<!--                            <div class="list-content">-->
<!--                                <p class="title">旅行平安保險</p>-->
<!--                                <p class="listCon">旅行期間因意外事故造成身亡或失能，依保額提供定額給付。</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="list">-->
<!--                            <div class="list-icon">-->
<!--                                <p class="color-black">必保<br><span>2</span></p>-->
<!--                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">-->
<!--                            </div>-->
<!--                            <div class="list-content">-->
<!--                                <p class="title">傷害醫療保險</p>-->
<!--                                <p class="listCon">若因旅程期間騎乘腳踏車不慎摔傷，以實際醫療費用給付醫療保險金。</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="list">-->
<!--                            <div class="list-icon">-->
<!--                                <p class="color-black">必保<br><span>3</span></p>-->
<!--                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">-->
<!--                            </div>-->
<!--                            <div class="list-content">-->
<!--                                <p class="title">個人賠償責任保險</p>-->
<!--                                <p class="listCon">-->
<!--                                    餐廳吃飯不慎將咖啡潑灑到鄰桌客人身上，導致需要賠償衣物、包包，提供保險金賠償。</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="footer">-->
<!--                    <div class="prize">-->
<!--                        <p>一日保費</p>-->
<!--                        <p class="hightlight"><span>$</span>130</p>-->
<!--                        <p>起</p>-->
<!--                    </div>-->
<!--                    <p class="safe-terms">(保費依旅平保額3百萬、傷害醫療30萬計算，保費將依保額、天數、人數變動)</p>-->
<!--                    <div class="btnArea">-->
<!--                        <router-link :to="'/count1'" class="btn theme_go_accu0" @click="goCount1('railsContent')">立即投保-->
<!--                        </router-link>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="popup-content  popup-motoContent">
                <div class="head">
                    <h3>離島租車遊 <span>保險方案推薦</span></h3>
                </div>
                <div class="close popup-close theme_close_accu1" @click="popupClose">
                    <img src="../../assets/close.svg" alt="close">
                </div>
                <div class="overFrame">
                    <div class="body">
                        <div class="list">
                            <div class="list-icon">
                                <p>推薦<br><span>1</span></p>
                                <img src="../../assets/popup-yellow-icon.svg" alt="popupYellowIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">境內班機延誤保險(含在國內旅遊不便險內)</p>
                                <p class="listCon">因飛機延誤達4小時以上，即可獲得定額2,000元補償。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p>推薦<br><span>2</span></p>
                                <img src="../../assets/popup-yellow-icon.svg" alt="popupYellowIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">國內租車旅遊險(機車)</p>
                                <p class="listCon">
                                    於綠島騎乘機車，不慎與對向機車對撞，提供機車維修費用與他人財損、受傷限額補償。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>1</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">旅行平安保險</p>
                                <p class="listCon">旅行期間因意外事故造成身亡或失能，依保額提供定額給付。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>2</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">傷害醫療保險</p>
                                <p class="listCon">若因旅程期間騎乘腳踏車不慎摔傷，以實際醫療費用給付醫療保險金。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>3</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">個人賠償責任保險</p>
                                <p class="listCon">
                                    餐廳吃飯不慎將咖啡潑灑到鄰桌客人身上，導致需要賠償衣物、包包等，提供保險金賠償。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="prize">
                        <p>一日保費</p>
                        <p class="hightlight"><span>$</span>185</p>
                        <p>起</p>
                    </div>
                    <p class="safe-terms">(保費依旅平保額5百萬、傷害醫療5萬計算，保費將依保額、天數、人數變動)</p>
                    <div class="btnArea">
                        <div class="btn theme_go_accu1" @click="goCount1('motoContent')">立即投保
                        </div>
                    </div>
                </div>

            </div>
            <div class="popup-content  popup-carContent">
                <div class="head">
                    <h3>租車自駕遊 <span>保險方案推薦</span></h3>
                </div>
                <div class="close popup-close theme_close_accu2" @click="popupClose">
                    <img src="../../assets/close.svg" alt="">
                </div>
                <div class="overFrame">
                    <div class="body">
                        <div class="list">
                            <div class="list-icon">
                                <p>推薦<br><span>1</span></p>
                                <img src="../../assets/popup-yellow-icon.svg" alt="popupYellowIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">國內租車旅遊險(汽車)</p>
                                <p class="listCon">
                                    於國內租車與其他車輛發生碰撞事故，提供車輛維修費用與他人財損受傷限額保險金。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p>推薦<br><span>2</span></p>
                                <img src="../../assets/popup-yellow-icon.svg" alt="popupYellowIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">國道或大眾運輸交通事故保險</p>
                                <p class="listCon">
                                    在國道上發生意外或是搭乘大眾運輸工具發生意外，導致不幸身故，最高理賠200萬元。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>1</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">旅行平安保險</p>
                                <p class="listCon">旅行期間因意外事故造成身亡或失能，依保額提供定額給付。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>2</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">傷害醫療保險</p>
                                <p class="listCon">若因旅程期間騎乘腳踏車不慎摔傷，以實際醫療費用給付醫療保險金。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>3</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">個人賠償責任保險</p>
                                <p class="listCon">
                                    餐廳吃飯不慎將咖啡潑灑到鄰桌客人身上，導致需要賠償衣物、包包，提供保險金賠償。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="prize">
                        <p>一日保費</p>
                        <p class="hightlight"><span>$</span>338</p>
                        <p>起</p>
                    </div>
                    <p class="safe-terms">(保費依旅平保額5百萬、傷害醫療5萬計算，保費將依保額、天數、人數變動)</p>
                    <div class="btnArea">
                        <div class="btn theme_go_accu2" @click="goCount1('carContent')">立即投保
                        </div>
                    </div>
                </div>
            </div>
            <div class="popup-content  popup-basicContent">
                <div class="head">
                    <h3>基本保障款 <span>保險方案推薦</span></h3>
                </div>
                <div class="close popup-close theme_close_accu3" @click="popupClose">
                    <img src="../../assets/close.svg" alt="close">
                </div>
                <div class="overFrame">
                    <div class="body">
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>1</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">旅行平安保險</p>
                                <p class="listCon">旅行期間因意外事故造成身亡或失能，依保額提供定額給付。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>2</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">傷害醫療保險</p>
                                <p class="listCon">若因旅程期間騎乘腳踏車不慎摔傷，以實際醫療費用給付醫療保險金。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>3</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">個人賠償責任保險</p>
                                <p class="listCon">
                                    餐廳吃飯不慎將咖啡潑灑到鄰桌客人身上，導致需要賠償衣物、包包，提供保險金賠償。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="prize">
                        <p>一日保費</p>
                        <p class="hightlight"><span>$</span>74</p>
                        <p>起</p>
                    </div>
                    <p class="safe-terms">(保費依旅平保額3百萬、傷害醫療5萬計算，保費將依保額、天數、人數變動)</p>
                    <div class="btnArea">
                        <div class="btn theme_go_accu3" @click="goCount1('basicContent')">立即投保
                        </div>
                    </div>
                </div>
            </div>
            <div class="popup-content  popup-campContent">
                <div class="head">
                    <h3>自然露營趣 <span>保險方案推薦</span></h3>
                </div>
                <div class="close popup-close theme_close_accu4" @click="popupClose">
                    <img src="../../assets/close.svg" alt="">
                </div>
                <div class="overFrame">
                    <div class="body">
                        <div class="list">
                            <div class="list-icon">
                                <p>推薦<br><span>1</span></p>
                                <img src="../../assets/popup-yellow-icon.svg" alt="popupYellowIcon">
                            </div>
<!--                            <div class="list-content">-->
<!--                                <p class="title">重大燒燙傷保險</p>-->
<!--                                <p class="listCon">-->
<!--                                    露營不免烤肉、野炊、升營火，活動期間若不慎造成燒燙傷，依100萬保額按燒傷程度的比例給付保險金。</p>-->
<!--                            </div>-->
                            <div class="list-content">
                                <p class="title">食物中毒慰問金</p>
                                <p class="listCon">
                                    露營不免烤肉、野炊，活動期間若不慎造成食物中毒，將依保額提供定額保險金。 </p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p>推薦<br><span>2</span></p>
                                <img src="../../assets/popup-yellow-icon.svg" alt="popupYellowIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">國道或大眾運輸交通事故險</p>
                                <p class="listCon">前往營地不免路經國道，若不幸因意外造成身故提供定額保險金。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>1</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">旅行平安保險</p>
                                <p class="listCon">旅行期間因意外事故造成身亡或失能，依保額提供定額給付。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>2</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">傷害醫療保險</p>
                                <p class="listCon">若因旅程期間騎乘腳踏車不慎摔傷，以實際醫療費用給付醫療保險金。</p>
                            </div>
                        </div>
                        <div class="list">
                            <div class="list-icon">
                                <p class="color-black">必保<br><span>3</span></p>
                                <img src="../../assets/popup-green-icon.svg" alt="popupGreenIcon">
                            </div>
                            <div class="list-content">
                                <p class="title">個人賠償責任保險</p>
                                <p class="listCon">
                                    餐廳吃飯不慎將咖啡潑灑到鄰桌客人身上，導致需要賠償衣物、包包，提供保險金賠償。</p>
                            </div>
                        </div>
                        <a href=""></a>
                    </div>
                </div>
                <div class="footer">
                    <div class="prize">
                        <p>一日保費</p>
                        <p class="hightlight"><span>$</span>159</p>
                        <p>起</p>
                    </div>
                    <p class="safe-terms">(保費依旅平保額5百萬、傷害醫療5萬計算，保費將依保額、天數、人數變動)</p>
                    <div class="btnArea">
                        <div class="btn theme_go_accu4" @click="goCount1('campContent')">立即投保
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
        import _ from "lodash";
        import gtm from "@/utils/gtmDataLayer";
        import {onBeforeMount, onBeforeUnmount, onMounted, ref} from "vue";
        import $ from "jquery"
        import {useRouter} from "vue-router";

        const router = useRouter();
        const infoBox = ref(null);
        let themeHeight = 0;

        const initNavFixedEvent = _.throttle(() => {
            themeHeight = infoBox.value.clientHeight;
            let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop//滾動高度
            if (scrollHeight + 80 > infoBox.value.offsetTop && scrollHeight < infoBox.value.offsetTop + themeHeight - 80) {
                $('.travel-nav-fixed').addClass('fixed');
                $('.scrollContainer').addClass('fixed');
                var triggerAry = [];
                $('.theme-container > .journey').each(function (index, item) {
                    if (scrollHeight + 200 + $('.travel-nav-fixed').height() > $(item).position().top) {
                        triggerAry.push($(item).find('[id]').attr('id'));
                    }
                });
                console.log("triggerAry", triggerAry);
                if (triggerAry.length > 0) {
                    $("[data-anchor=".concat(triggerAry[triggerAry.length - 1], "]")).addClass('active').siblings().removeClass('active');
                    $('.travel-nav').scrollLeft($("[data-anchor=".concat(triggerAry[triggerAry.length - 1], "]")).position() + $('.travel-nav').scrollLeft());
                }
            } else {
                $('.travel-nav-fixed').removeClass('fixed');
                $('.scrollContainer').removeClass('fixed');
                $('.travel-nav li').removeClass('active');
                $('.travel-nav').scrollLeft(0);
            }
            },300);
        const  popupShow=(event)=> {
            var popupTarget = event.currentTarget.id;
            $('.popup-wrapper').find(".popup-".concat(popupTarget)).addClass('active').siblings().removeClass('active').end().end().fadeIn();
            $('body').css('overflow', 'hidden');
            sendDataLayer('select_item', popupTarget);
        }
        const popupClose = () => {
            $('.popup-wrapper').fadeOut();
            $('body').css('overflow', 'initial');
        }
        const clickToScroll = () => {
            let areaSize = window.innerWidth < 768 ? 140 : 270;
            window.addEventListener('resize', () => {
                areaSize = window.innerWidth < 768 ? 140 : 270;
            });

            $('[data-anchor]').on('click', function () {
                var offsetTop = $("#".concat($(this).data('anchor'))).offset().top;
                $("html, body").animate({
                    scrollTop: offsetTop + areaSize - $('.travel-nav-fixed').outerHeight()
                }, 300);
            });
        }
        const  changeSize = () =>{
            themeHeight = infoBox.value.clientHeight;
            $('.travel-nav-fixed').removeClass('fixed');
        }
        const goCount1 = (content) => {
            sendDataLayer('view_item', content);
            router.push('/count1');
        }
        const sendDataLayer = (event, content) => {
            //dataLayer push
            let dataLayerValue = 1000;
            let itemListId = '';
            let itemListName = '';
            switch (content){
                case 'railsContent':
                    dataLayerValue = 130;
                    itemListId = 'recommend_taiwan_1';
                    itemListName = '鐵道客運遊';
                    break;
                case 'motoContent':
                    dataLayerValue = 197;
                    itemListId = 'recommend_taiwan_2';
                    itemListName = '離島租車遊';
                    break;
                case 'carContent':
                    dataLayerValue = 370;
                    itemListId = 'recommend_taiwan_3';
                    itemListName = '租車自駕遊';
                    break;
                case 'basicContent':
                    dataLayerValue = 68;
                    itemListId = 'recommend_taiwan_4';
                    itemListName = '基本保障款';
                    break;
                case 'campContent':
                    dataLayerValue = 166;
                    itemListId = 'recommend_taiwan_5';
                    itemListName = '自然露營趣';
                    break;
            }
            gtm.policyEvent(event, dataLayerValue, null, null, null, null, itemListId, itemListName)
        }

        onBeforeMount(() => {
            window.addEventListener('scroll', initNavFixedEvent);
            window.addEventListener('resize', changeSize);
        });

        onMounted(() => {
            clickToScroll()
        })

        onBeforeUnmount(() => {
            window.removeEventListener('scroll', initNavFixedEvent);
            window.removeEventListener('resize', changeSize);
        })

</script>

<style lang="scss">
.travelTheme {
    padding-top: 60px;
    padding-bottom: 85px;
    background:$lightBlue;
    .travel-nav-container {
        .travel-nav-fixed {
            padding-top: 20px;
            &.fixed {
                position: fixed;
                top: 93px;
                z-index: 10;
                left: 50%;
                -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
                background-color: $lightBlue;
                width: 100%;
                @media screen and (max-width: $pad) {
                    .travel-nav{padding-top:20px;}
                }
                @media screen and (max-width: $padMini) {
                    top: 61px;
                    .travel-nav li:first-child {
                        margin-left: 20px;
                    }
                    .travel-nav li:first-child {
                        margin-left: 20px;
                    }
                    .title {
                        font-size: 20px;
                        padding: 5px 0;
                    }
                }
            }

        }

        .travel-nav {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            padding-bottom: 25px;
            padding-top: 40px;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            @media screen and (max-width: $padMini) {
                padding-top: 15px
            }
            @media screen and (max-width: $small) {
                -webkit-box-pack: start;
                -ms-flex-pack: start;
                justify-content: flex-start;
                overflow-x: scroll;
                padding-bottom: 20px;
                width: 100%;
                position: relative;
            }

            li {
                background: white;
                -ms-flex-negative: 0;
                flex-shrink: 0;
                border-radius: $radius;
                cursor: pointer;
                -webkit-transition: .3s all;
                transition: .3s all;
                border: 2px solid #B6B6B7;
                @media screen and (max-width: $pad) {
                    border-radius:10px;
                }
                a {
                    color: $blue-700;
                    padding: 20px;
                    display: block;
                    font-weight: 500;
                    font-size: 24px;
                    @media screen and (max-width: $pad) {
                        padding: 10px;
                        font-size: 16px;
                    }
                }

                & ~ li {
                    margin-left: 20px;
                    @media screen and (max-width: $padMini) {
                        margin-left: 12px;
                    }
                }

                &:hover {
                    background: $blue-700;
                    border: 2px solid $blue-700;

                    a {
                        color: #fff
                    }
                }

                &.active {
                    background: $blue-700;
                    border: 2px solid $blue-700;

                    a {
                        color: #fff
                    }
                }
            }

            p {
                color: #a8a39a;
                margin: 0px;
                font-weight: 600;
                line-height: 1em;
            }
        }
    }

    .theme-container {
        width: 100%;
        max-width: 900px;
        margin: 0px auto;
        margin-bottom: 60px;
        .item {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            position: relative;
            margin: 120px 0;

            &:first-of-type {
                margin-top: 50px;
            }

            @media screen and (max-width: $padMini) {
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -ms-flex-direction: column;
                flex-direction: column;
            }

            & ~ .item {
                margin-top: 75px;
            }

            .image-wrapper {
                display: block;
                position: relative;
                z-index: 3;
                width: 370px;
                -ms-flex-negative: 0;
                flex-shrink: 0;
                top: -40px;
                img {
                    border:5px solid $blue-700;
                    box-sizing: border-box;
                    border-radius: 20px;
                }
                @media only screen and (max-width: $padMini) {
                    width: 85%;
                    align-self: baseline;
                    overflow: hidden;
                    top: 0;
                    left:-5px;
                    img {
                        width: 100%
                    }
                }

                .title {
                    display: none;
                    @media only screen and (max-width: $padMini) {
                        position: absolute;
                        bottom: 5px;
                        display: block;
                        -webkit-transform: none;
                        transform: none;
                        background-color: $blue-700;
                        color: #fff;
                        font-size: 18px;
                        padding: 10px 15px;
                        border-top-right-radius: 50px;
                        border-bottom-right-radius: 50px;
                    }
                }

                img {
                    width: 100%;
                }
            }

            .item-content {
                width: 100%;
                position: relative;
                padding-right: 20px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;

                &::before {
                    content: "";
                    position: absolute;
                    background-color: white;
                    border: 2px solid #EBECED;
                    top: 0px;
                    width: calc(100% + 276px);
                    height: calc(100% + 35px);
                    border-radius: 10px;
                    right: 0px;
                    box-shadow: 0px 4px 4px #CACCCF;
                    @media only screen and (max-width: $padMini) {
                        width: 100%;
                        height: calc(100% + 120px);
                        top: -120px;
                    }
                }

                .title {
                    color: #fff;
                    padding: 18px 30px;
                    background-color: $blue-700;
                    -webkit-transform: translateX(-10px);
                    transform: translateX(-10px);
                    position: relative;
                    left: 10px;
                    border-top-right-radius: 50px;
                    border-bottom-right-radius: 50px;
                    @media only screen and (max-width: $padMini) {
                        display: none;
                    }

                    h3 {
                        margin: 0px;
                        line-height: 1em;
                        position: relative;
                        font-size: 24px;
                        @media only screen and (max-width: $pad) {
                            font-size: 18px;
                        }
                    }
                }

                .head {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    justify-content: space-between;
                    -webkit-box-align: end;
                    -ms-flex-align: end;
                    align-items: flex-end;
                    position: relative;
                }

                .body {
                    padding-left: 25px;
                    padding-top: 25px;
                    position: relative;
                    @media only screen and (max-width: $padMini) {
                        padding-left: 20px;
                        padding-top: 0px;
                        margin: 0px auto;
                        margin-bottom: 20px;
                        margin-top: 20px;
                    }

                    p {
                        margin: 0px;
                        font-size: 16px;
                        line-height: 32px;
                        color: $textColor;
                        font-weight: bold;
                    }

                    .prize {
                        display: none;
                        @media only screen and (max-width: $padMini) {
                            display: -webkit-box;
                            display: -ms-flexbox;
                            display: flex;
                            -webkit-box-align: end;
                            -ms-flex-align: end;
                            align-items: flex-end;
                            -webkit-box-pack: center;
                            -ms-flex-pack: center;
                            justify-content: center;
                            margin: 10px 0;
                        }
                    }
                }

                a {
                    position: absolute;
                    right: 20px;
                    bottom: 5px;

                    &.btn {
                        padding: 16px;
                        width: auto;
                        margin: 0;

                        p {
                            font-size: 20px;
                            color: white;
                            font-weight: 900;
                            margin: 0px;
                            position: relative;
                            z-index: 2;
                            line-height: 1em;
                        }

                        @media only screen and (max-width: $padMini) {
                            position: relative;
                            right: auto;
                            right: initial;
                            bottom: auto;
                            bottom: initial;
                            margin: 0px auto;
                            display: table;
                            margin-bottom: 30px;
                        }
                    }

                }

                .prize {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: end;
                    -ms-flex-align: end;
                    align-items: flex-end;
                    margin-bottom: 2px;
                    @media only screen and (max-width: $padMini) {
                        display: none;
                    }

                    p {
                        font-size: 16px;
                        line-height: 20px;
                        color:$blue-700;
                        text-align: right;
                        margin: 0px;
                        font-weight: 600;

                        &:nth-of-type(3) {
                            color: $pink;
                            font-size: 20px;
                            line-height: 24px;
                        }
                    }

                    .hightlight {
                        font-size: 48px;
                        color: $pink;
                        font-weight: 600;
                        margin-left: 4px;
                        margin-right: 2px;
                        -webkit-transform: translateY(5px);
                        transform: translateY(5px);

                        span {
                            font-size: 24px;
                            line-height: 32px;
                        }
                    }
                }

            }

        }
    }
    .fixed .theme-container{
        padding-top:35%;
        //@media screen and (max-width: $padMini) {
        //    padding-top: 10%;
        //}
    }
    .journey{
        position: relative;
    }
    #moto,#car,#basic,#camp{
        position: absolute;
        margin-top: -430px;
        @media screen and (max-width: $padMini) {
            margin-top: -220px;
        }
    }
    .note {
        color: $gray;
        font-weight: bold;
    }

    .popup-wrapper {
        position: fixed;
        left: 0px;
        top: 0px;
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        z-index: 1000;

        .popup-content {
            padding: 105px 80px 30px 80px;
            position: relative;
            background: #FFFFFF;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 20px;
            position: absolute;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            width: 1024px;
            display: none;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            scroll-behavior: smooth;
            height: auto;
            max-height: 75%;
            overflow-y: auto;
            @media screen and (max-width: $padLandscape) {
                width: 90%;
                padding: 0;
            }

            &.active {
                display: inline;
                display: initial;
            }

            .head {
                position: absolute;
                left: 0px;
                top: 0px;
                background-color: $blue-700;
                border-top-right-radius: 50px;
                border-bottom-right-radius: 50px;
                padding: 12px 50px 12px 27px;

                h3 {
                    font-size: 30px;
                    margin: 0px;
                    line-height: 1em;
                    color: $popupYellow;

                    span {
                        color: white;
                    }

                    @media screen and (max-width: $pad) {
                        font-size: 20px;
                    }
                }

                @media screen and (max-width: $pad) {
                    padding: 10px 20px;
                }
            }

            .close {
                position: absolute;
                right: 20px;
                top: 20px;
                cursor: pointer;
                @media screen and (max-width: $pad) {
                    top: 10px;
                    right: 10px;
                }
            }

            .overFrame {
                height: 400px;
                overflow-y: scroll;
                box-sizing: border-box;
                padding: 15px 40px;
                border: 2px solid $blue-700;
                @media screen and (max-width: $pad) {
                    padding: 10px 15px;
                    height: 300px;
                    margin: 50px 20px 0;
                    right: 10px;
                }

                &::-webkit-scrollbar {
                    width: 5px;
                    height: 8px;
                    background: $btnGray;
                    border-radius: 10px
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    background-color: $blue-700;
                    margin-right: 10px;
                }
            }

            .body {
                margin-bottom: 27px;

                .list {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    margin: 20px 0;

                    .list-icon {
                        position: relative;

                        p {
                            position: absolute;
                            color: white;
                            left: 50%;
                            top: 50%;
                            -webkit-transform: translate(-50%, -50%);
                            transform: translate(-50%, -50%);
                            margin: 0px;
                            font-size: 22px;
                            font-weight: bold;
                            text-align: center;

                            span {
                                font-size: 36px;
                                line-height: 30px;
                                font-family: 'Noto Sans TC', '微軟正黑體', sans-serif;
                            }
                        }

                        @media screen and (max-width: $pad) {
                            p {
                                font-size: 16px;

                                span {
                                    font-size: 25px;
                                    line-height: 25px;
                                }
                            }
                            img {
                                width: 75px;
                            }
                        }
                    }

                    .list-content {
                        margin-left: 20px;
                        width: calc(100% - 105px);
                        @media screen and (max-width: $pad) {
                            font-size: 16px;
                            width: calc(100% - 70px);
                        }

                        .title {
                            font-size: 24px;
                            margin: 0px;
                            margin-bottom: 9px;
                            font-weight: bold;
                            color: $textColor;
                            text-align: left;
                            padding: 0;
                        }

                        .listCon {
                            font-size: 20px;
                            margin: 0px;
                            color: #000;
                        }

                        @media screen and (max-width: $pad) {
                            .title {
                                font-size: 20px
                            }
                            .listCon {
                                font-size: 16px;

                                img {
                                    width: 50px
                                }
                            }
                        }
                        @media screen and (max-width: $small) {
                            .title {
                                font-size: 16px;
                                font-family: 'Poppins', 'Noto Sans TC', sans-serif;
                            }
                            .listCon {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }

            .footer {
                text-align: center;
                margin: 15px 0;

                .prize {
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: end;
                    -ms-flex-align: end;
                    align-items: flex-end;
                    margin-bottom: 2px;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;

                    p {
                        font-size: 24px;
                        line-height: 35px;
                        color: $blue-700;
                        text-align: right;
                        margin: 0px;
                        font-weight: 600;
                    }

                    .hightlight {
                        font-size: 40px;
                        line-height: 50px;
                        color: $pink;
                        font-weight: 600;
                        margin-left: 4px;
                        margin-right: 2px;
                        -webkit-transform: translateY(5px);
                        transform: translateY(5px);
                    }
                }

                .safe-terms {
                    font-size: 18px;
                    line-height: 50px;
                }

                @media screen and (max-width: $pad) {
                    .safe-terms {
                        line-height: 30px;
                        margin: 20px;
                        text-align: left;
                    }
                    .btnArea {
                        margin: 0 0 30px;
                    }
                }
            }
        }
    }
}

</style>